import { render, staticRenderFns } from "./import-logistics-provider-modal.vue?vue&type=template&id=20c8b881&scoped=true&"
import script from "./import-logistics-provider-modal.vue?vue&type=script&lang=js&"
export * from "./import-logistics-provider-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c8b881",
  null
  
)

export default component.exports